export default {
  loggedUser: null
}